import { Box, BoxProps } from "@mui/material";

interface PrintComponentCriteriasProps extends BoxProps {
    criterias?: string[];
}

export default function PrintComponentCriterias({
    criterias = [],
    ...props
}: PrintComponentCriteriasProps) {
    const renderCriteria = criterias.filter(Boolean);

    return renderCriteria.length > 0 && <Box {...props}>
        <Box component={"span"} fontWeight={"bold"}>Criterios:</Box>
        <Box component={"ul"}>
            {renderCriteria.map(s => <Box key={s} component={"li"}>{s}</Box>)}
        </Box>
    </Box>
}